export const isOfflineConfirmed = (health) => {
  if (!health || !health.incident_id) return false;
  if (health.offline_confirmed === true) return true;
  return Number(health.offline_duration_seconds) >= 300;
};

const UNKNOWN = { text: 'Неизвестно', color: 'secondary' };
const NO_DATA = { text: 'Нет данных', color: 'secondary' };

// GET /cameras/{id} возвращает health_summary не всегда (в детальной карточке он
// приходит null), поэтому статус приходится собирать из ответа
// GET /cameras/{id}/connection. Он бывает и плоским, и с вложенным incident.
export const connectionToHealthSummary = (connection) => {
  if (!connection || !connection.connection_status) return null;
  const incident = connection.incident || {};
  return {
    desired_running: connection.desired_running,
    connection_status: connection.connection_status,
    // В ответе /connection идентификатор активного инцидента лежит в incident.id.
    incident_id: incident.id ?? incident.incident_id ?? connection.incident_id ?? null,
    offline_confirmed: incident.offline_confirmed ?? connection.offline_confirmed,
    offline_duration_seconds:
      incident.duration_seconds ?? incident.incident_duration_seconds ?? connection.offline_duration_seconds ?? null,
  };
};

export const deriveCameraDisplayStatus = (camera, connection) => {
  if (!camera) return NO_DATA;

  const status = (camera.status || '').toUpperCase();
  if (status === 'PENDING_DELETE') return { text: 'На удалении', color: 'warning' };
  if (status === 'DELETED') return { text: 'Удалена', color: 'dark' };

  const health = camera.health_summary || connectionToHealthSummary(connection);
  if (!health) return NO_DATA;

  if (health.desired_running === false) return { text: 'Остановлена', color: 'secondary' };

  const cs = (health.connection_status || '').toUpperCase();
  if (cs === 'ONLINE') return { text: 'Онлайн', color: 'success' };
  if (cs === 'RETRYING') return { text: 'Проверка соединения', color: 'info' };
  if (cs === 'RETRY_WAIT') {
    return isOfflineConfirmed(health)
      ? { text: 'Недоступна', color: 'danger' }
      : { text: 'Переподключение', color: 'warning' };
  }
  return UNKNOWN;
};
